import React from 'react';

interface LogoProps {
  /** md : barres d'en-tête ; lg : pages d'accueil et d'authentification */
  size?: 'md' | 'lg';
  /** Sur fond sombre : le nom passe en blanc */
  onDark?: boolean;
  className?: string;
}

/** La marque ArchiFacil, la même partout : la maison bleue et « ArchiFacil ». */
export function Logo({ size = 'md', onDark = false, className = '' }: LogoProps) {
  return (
    <div className={`af-brand${size === 'lg' ? ' lg' : ''}${onDark ? ' on-dark' : ''} ${className}`.trim()}>
      <div className="logo">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 10.5 12 3l9 7.5" />
          <path d="M5 9.5V21h14V9.5" />
          <path d="M9.5 21v-6h5v6" />
        </svg>
      </div>
      <div className="name">Archi<b>Facil</b></div>
    </div>
  );
}
